<template>
  <div class="infoTextWrapper">
    <p>
      Få dina gavlar färdigmonterade istället för omonterade. Sparar tid vid montering och säkerställer att gavlarna är monterade på ett godkänt sätt.
    </p>
  </div>
</template>

<script>

import AssembledUprightsInfo from "@/components/infotext/AssembledUprightsInfo.vue";

export default {
  components: {
    AssembledUprightsInfo
  }
}

</script>